export default __webpack_public_path__ + "static/media/submarine.cc9f88f3.png";